import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import ShowHistoryChanges from 'components/HistoryChanges';
import DiscountMatrixTable from '../DiscountMatrixTable';
import {
  AlertBox,
  Badge,
  ChangeDetail,
  Divider,
  HistorySection,
  MatrixContainer,
  MatrixHeading,
  MatrixSection,
  ProductItem,
  ProductList,
  ProductName,
  SectionTitle
} from './styled';
import { useSelector } from 'react-redux';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';

const ChangesDetailModal = ({
  isOpen,
  toggle,
  removedProducts = [],
  changedProducts = [],
  originalMatrix = [],
  updatedMatrix = [],
  discountMatrixChanged = false,
  catalogChangesHistory = [],
  onUpdateProducts = () => {},
  useUpdatedDiscountMatrix,
  onApplyUpdatedMatrix,
  onRevertToOriginalMatrix
}) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Detalhes das Alterações no Catálogo
      </ModalHeader>

      <ModalBody>
        {removedProducts.length > 0 && (
          <>
            <SectionTitle>
              Produtos Removidos
              <Badge color="danger">{removedProducts.length}</Badge>
            </SectionTitle>

            <ProductList>
              {removedProducts.map((p) => (
                <ProductItem key={`removed-${p.productId}`} type="removed">
                  <ProductName>{p.productName}</ProductName>
                  <span>
                    Preço original: R$ {parseFloat(p.basePrice).toFixed(2)}
                  </span>
                </ProductItem>
              ))}
            </ProductList>
          </>
        )}

        {changedProducts.length > 0 && (
          <>
            <SectionTitle>
              Produtos Alterados
              <Badge color="warning">{changedProducts.length}</Badge>
            </SectionTitle>

            <ProductList>
              {changedProducts.map((p) => (
                <ProductItem key={`changed-${p.productId}`} type="changed">
                  <ProductName>{p.productName}</ProductName>
                  {p.changes &&
                    p.changes.map((change, i) => (
                      <ChangeDetail key={`change-${p.productId}-${i}`}>
                        {change.field === 'price' ? (
                          <span>
                            Preço:{' '}
                            <strong>R$ {change.oldValue.toFixed(2)}</strong> →{' '}
                            <strong>R$ {change.newValue.toFixed(2)}</strong>
                          </span>
                        ) : change.field === 'name' ? (
                          <span>
                            Nome: <strong>{change.oldValue}</strong> →{' '}
                            <strong>{change.newValue}</strong>
                          </span>
                        ) : null}
                      </ChangeDetail>
                    ))}
                </ProductItem>
              ))}
            </ProductList>
            <AlertBox type="info">
              <strong>Observação:</strong> Ao atualizar produtos alterados, os
              preços atuais dos produtos serão substituídos pelos novos preços
              definidos no catálogo.
            </AlertBox>
            <div>
              <Button
                style={buttonStyle(systemConfiguration.primary_color)}
                onClick={onUpdateProducts}
              >
                Atualizar Produtos Alterados
              </Button>
            </div>
          </>
        )}

        {discountMatrixChanged && (
          <>
            <Divider />
            <SectionTitle>Matriz de Descontos Alterada</SectionTitle>

            <MatrixSection>
              <MatrixContainer>
                <MatrixHeading isOriginal>Matriz Original</MatrixHeading>
                <DiscountMatrixTable matrix={originalMatrix} />
              </MatrixContainer>

              <MatrixContainer>
                <MatrixHeading>Matriz Atualizada</MatrixHeading>
                <DiscountMatrixTable matrix={updatedMatrix} />
              </MatrixContainer>

              <AlertBox type="info">
                <strong>Observação:</strong> Ao aplicar a matriz atualizada, os
                valores de todos os produtos serão recalculados de acordo com as
                novas regras de desconto. Para mais detalhes sobre o que foi
                alterado, consulte o histórico completo de alterações.
              </AlertBox>

              <div>
                {!useUpdatedDiscountMatrix ? (
                  <Button
                    style={buttonStyle(systemConfiguration.primary_color)}
                    onClick={onApplyUpdatedMatrix}
                  >
                    Usar matriz atualizada
                  </Button>
                ) : (
                  <Button color="danger" onClick={onRevertToOriginalMatrix}>
                    Voltar para matriz original
                  </Button>
                )}
              </div>
            </MatrixSection>
          </>
        )}

        <Divider />

        <HistorySection>
          <SectionTitle>Histórico Completo de Alterações</SectionTitle>
          {catalogChangesHistory && catalogChangesHistory.length > 0 ? (
            <ShowHistoryChanges data={catalogChangesHistory} />
          ) : (
            <p style={{ color: '#6c757d', fontStyle: 'italic' }}>
              Nenhum histórico de alterações disponível.
            </p>
          )}
        </HistorySection>
      </ModalBody>

      <ModalFooter>
        <Button
          style={buttonStyle(systemConfiguration.cancelation_button_color)}
          onClick={toggle}
        >
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ChangesDetailModal;
